import { type RefObject, useEffect } from 'react';

import type { MapRef } from 'react-map-gl/mapbox';

import { INTERACTIVE_LAYERS } from '@/utils/constants/map';

const useMapInteractivity = (mapRef: RefObject<MapRef | null>, isMapLoaded: boolean) => {
  useEffect(() => {
    if (!mapRef) {
      return;
    }

    const map = mapRef.current?.getMap();

    if (!isMapLoaded || !map) {
      return;
    }

    const setCursorToPointer = () => {
      map.getCanvas().style.cursor = 'pointer';
    };

    const resetCursor = () => {
      map.getCanvas().style.cursor = '';
    };

    for (const layerId of INTERACTIVE_LAYERS) {
      map.on('mouseenter', layerId, setCursorToPointer);
      map.on('mouseleave', layerId, resetCursor);
    }

    return () => {
      if (!map.getStyle()) {
        return;
      }

      for (const layerId of INTERACTIVE_LAYERS) {
        map.off('mouseenter', layerId, setCursorToPointer);
        map.off('mouseleave', layerId, resetCursor);
      }
    };
  }, [isMapLoaded, mapRef]);
};

export default useMapInteractivity;
